import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Header from "../home/header";
import Loading from "../home/Loading";
import Login from "../home/login_form";
import { useLocation, useNavigate } from "react-router";
import UTILS from "../../utils/commons";
import { ApiClient } from "../../utils/api-client";

const SaleForm = props => {
    var navigate = useNavigate();
    const loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
    const apiClient = new ApiClient( loginState ? loginState.accessToken : null );

    // ...existing code...
    const [ customers, setCustomers ] = useState( [] );
    const [ issues, setIssues ] = useState( [] );
    const [ products, setProducts ] = useState( [] );
    const [ isLoading, setIsLoading ] = useState( false );
    const [ feedback, setFeedback ] = useState( "" );

    const initialValues = {
        transaction_type: 0,
        customer: 0,
        product: 0,
        invoiceNumber: '',
        quantity: 1,
        price: 0,
        amount: 0,
        document_file: null
    };

    const validationSchema = Yup.object( {
        transaction_type: Yup.number().required(),
        customer: Yup.string().required( "Required" ),
        product: Yup.string().required( "Required" ),
        invoiceNumber: Yup.string().required( "Required" ),
        quantity: Yup.number().min( 1, "Quantity must be at least 1" ).required( "Required" ),
        price: Yup.number().min( 1, "Price must be at least 1" ).required( "Required" ),
        amount: Yup.number().min( 1, "Amount must be at least 1" ).required( "Required" ),
    } );

    const handleSubmit = async ( values, { setSubmitting, setFieldError } ) => {
        setIsLoading( true );
        let transaction = {
            type: parseInt( values.transaction_type ),
            customerId: values.customer,
            productId: values.product,
            invoiceNumber: values.invoiceNumber,
            quantity: parseInt( values.quantity ),
            price: values.price,
            amount: values.amount,
            profileId: loginState.profile.id
        };
        if ( values.document_file ) {
            transaction.file = values.document_file;
        }
        if ( transaction.productId == 0 || transaction.customerId == 0 || transaction.invoiceNumber === "" || transaction.quantity == 0 ) {
            setFeedback( "Please fill in the missing information" );
            setIsLoading( false );
            setSubmitting( false );
        } else {
            await saveTransaction( transaction );
            setIsLoading( false );
            setSubmitting( false );
        }
    };
    //save transaction
    const saveTransaction = async ( transaction ) => {

        var options = {
            method: "POST",
            body: transaction,

        }
        try {
            const result = await apiClient.post( "transactions", transaction )
            console.log( "🚀 ~ saveTransaction ~ result:", result )

        } catch ( error ) {
            setFeedback( "An error occurred while saving the transaction. Please try again." );
        }

    }


    // All form state and logic is now handled by Formik

    const loadData = async () => {
        setIsLoading( true );
        const [ customersPromise, issuesPromise ] = await Promise.all( [
            apiClient.get( `customers/profile/${loginState.profile.id}` ),
            apiClient.get( `issues/profile/${loginState.profile.id}` ),
            //   apiClient.get(`products/profile/${loginState.profile.id}`)
        ] );

        setIsLoading( false );
        if ( customersPromise.status === 200 ) {
            const customersData = await customersPromise.data;
            setCustomers( customersData );
        }
        if ( issuesPromise.status === 200 ) {
            const issuesData = await issuesPromise.data;
            setIssues( issuesData );
            setProducts( issuesData.map( i => {
                return { ...i.product, price: Number( i.sellingPrice ), invoiceNumber: i.invoiceNumber, quantity: i.quantity, availableQuantity: ( i.quantity - i.sold ) };
            } ) );
        }


    }
    // Amount calculation is handled inside Formik render props

    useEffect( () => {
        loadData();
    }, [] )
    if ( loginState ) {
        return (
            <>
                <Header auth={loginState} />
                <section className="flex justify-start items-start">
                    <div className="container mx-auto md:mt-16">
                        {feedback.length > 0 ? <div className="alert text-center danger" id="form-feedback">{feedback}</div> : null}
                        <div className="md:flex md:items-start md:w-10/12 md:mx-auto border shadow py-16">
                            <div className="text-center mx-auto w-full">
                                <p className="text-center text-2xl my-8 ">Make a Sale</p>
                                <Formik
                                    initialValues={initialValues}
                                    validationSchema={validationSchema}
                                    onSubmit={handleSubmit}
                                >
                                    {( { values, setFieldValue, errors, touched, isSubmitting } ) => {
                                        // Handler for product change to auto-fill dependent fields
                                        const handleProductChange = e => {
                                            const productId = e.target.value;
                                            setFieldValue( 'product', productId );
                                            if ( productId && productId !== "0" ) {
                                                const selected = products.find( p => String( p.id ) === String( productId ) );
                                                if ( selected ) {
                                                    setFieldValue( 'quantity', selected.availableQuantity || 1 );
                                                    setFieldValue( 'price', selected.price || 0 );
                                                    setFieldValue( 'invoiceNumber', selected.invoiceNumber || '' );
                                                    setFieldValue( 'amount', ( selected.price || 0 ) * ( selected.availableQuantity || 1 ) );
                                                }
                                            } else {
                                                setFieldValue( 'quantity', 1 );
                                                setFieldValue( 'price', 0 );
                                                setFieldValue( 'invoiceNumber', '' );
                                                setFieldValue( 'amount', 0 );
                                            }
                                        };
                                        // Handler for price change to recalculate amount
                                        const handlePriceChange = e => {
                                            const price = Number( e.target.value );
                                            setFieldValue( 'price', price );
                                            setFieldValue( 'amount', price * values.quantity );
                                        };
                                        // Handler for quantity change to recalculate amount
                                        const handleQuantityChange = e => {
                                            const quantity = Number( e.target.value );
                                            setFieldValue( 'quantity', quantity );
                                            setFieldValue( 'amount', values.price * quantity );
                                        };
                                        return (
                                            <Form id="sale_form" className="text-start w-10/12 md:w-9/12 mx-auto">
                                                <div className="row">
                                                    <div className="form-group my-2 w-10/12 md:w-6/12">
                                                        <label htmlFor="transaction_type">Transaction Type</label>
                                                        <Field as="select" className="form-control" id="transaction_type" name="transaction_type">
                                                            <option value="0">Cash Sale</option>
                                                            <option value="1">Credit Sale</option>
                                                        </Field>
                                                    </div>
                                                    <div className="form-group my-2 w-10/12 md:w-6/12">
                                                        <label htmlFor="customer">Customer</label>
                                                        <Field as="select" className="form-control" id="customer" name="customer">
                                                            <option value="0">--select customer--</option>
                                                            {customers.map( c => (
                                                                <option key={c.id} value={c.id}>{c.name}</option>
                                                            ) )}
                                                        </Field>
                                                        {errors.customer && touched.customer ? <div className="text-danger">{errors.customer}</div> : null}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="form-group my-2 w-10/12 md:w-6/12">
                                                        <label htmlFor="product">Product</label>
                                                        <Field as="select" className="form-control" id="product" name="product" onChange={handleProductChange} value={values.product}>
                                                            <option value="0">--select product--</option>
                                                            {products.map( p => (
                                                                <option key={p.id} value={p.id}>{`${p.productName} (${p.packSize})`}</option>
                                                            ) )}
                                                        </Field>
                                                        {errors.product && touched.product ? <div className="text-danger">{errors.product}</div> : null}
                                                    </div>
                                                    <div className="form-group my-2 w-10/12 md:w-6/12 ">
                                                        <label htmlFor="invoiceNumber">Invoice Number </label>
                                                        <Field className="form-control" id="invoiceNumber" name="invoiceNumber" disabled />
                                                        {errors.invoiceNumber && touched.invoiceNumber ? <div className="text-danger">{errors.invoiceNumber}</div> : null}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="form-group my-2 w-10/12 md:w-6/12">
                                                        <label htmlFor="quantity">Quantity (cartons)</label>
                                                        <Field
                                                            type="number"
                                                            className="form-control"
                                                            id="quantity"
                                                            name="quantity"
                                                            min="1"
                                                            placeholder="No. of cartons"
                                                            value={values.quantity}
                                                            onChange={handleQuantityChange}
                                                        />
                                                        {errors.quantity && touched.quantity ? <div className="text-danger">{errors.quantity}</div> : null}
                                                    </div>
                                                    <div className="form-group my-2 w-10/12 md:w-6/12">
                                                        <label htmlFor="price">Price </label>
                                                        <Field
                                                            type="number"
                                                            className="form-control"
                                                            id="price"
                                                            name="price"
                                                            placeholder="Price"
                                                            value={values.price}
                                                            onChange={handlePriceChange}
                                                        />
                                                        {errors.price && touched.price ? <div className="text-danger">{errors.price}</div> : null}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="form-group my-2 w-10/12 md:w-6/12">
                                                        <label htmlFor="amount">Amount </label>
                                                        <Field
                                                            type="text"
                                                            disabled
                                                            className="form-control"
                                                            id="amount"
                                                            name="amount"
                                                            value={UTILS.thousandSeparator( values.amount )}
                                                        />
                                                    </div>
                                                    <div className="form-group my-2 my-2 my-2 col-md-6 col-lg-6 col-sm-10">
                                                        <label htmlFor="document_file">Supporting Document</label>
                                                        <input type="file" className="form-control" id="document_file" name="document_file" onChange={e => setFieldValue( "document_file", e.currentTarget.files[ 0 ] )} />
                                                    </div>
                                                </div>
                                                <div className="form-group my-2 row">
                                                    <div className="my-2 col-md-6 col-lg-6 col-sm-10">
                                                        {isLoading ? <Loading /> : (
                                                            <button type="submit" className="form-control bg-success" id="btnSubmit" name="btnSubmit" disabled={isSubmitting}>SUBMIT</button>
                                                        )}
                                                    </div>
                                                    <div className="my-2 col-md-6 col-lg-6 col-sm-10">
                                                        <input onClick={() => { navigate( -1, { replace: true } ) }}
                                                            type="button"
                                                            className="form-control"
                                                            value="Cancel"
                                                        />
                                                    </div>
                                                </div>
                                            </Form>
                                        );
                                    }}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }
    return <Login target='/sales' />

}
export default SaleForm;
